module.exports = {
  handle: (e, data) => {   
      dataLayer.push({ ecommerce: null });        
      dataLayer.push({
          'event': `e.${data.eventName}Start`,
          productName: data.productName
      });
  }
}